export const parseConversationUniqueName = (uniqueName: string) => {
  const clientId = parseInt(uniqueName.split('c:')[1]?.split('-')[0], 10)
  const therapistUserId = parseInt(uniqueName.split('t:')[1], 10)
  return { therapistUserId, clientId }
}
